export function filterDuplicatesByKeys<T>(objects: T[], key: keyof T): T[] {
  const seenKeys = new Set<unknown>()

  return objects.filter((obj) => {
    if (seenKeys.has(obj[key])) {
      return false // Duplicate key, exclude this object
    } else {
      seenKeys.add(obj[key])
      return true // Unique key, include this object
    }
  })
}
